/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetPayersForCustomerRequest} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'
import {SetPayersForCustomerResponse} from '@cash-web/protos/squareup/cash/paychecks/api/v1/paychecks_app_service.pb'


export const setPayersForCustomer = (request: SetPayersForCustomerRequest, options?: CashRequestOptions) => post<SetPayersForCustomerRequest, SetPayersForCustomerResponse>("/2.0/cash/set-payers-for-customer", request, {...options, rejectOnError: true })